import React from 'react';
import useMatchMedia from '../../utils/hooks/useMatchMedia';
// Use this to wrap around components that should only render when matching a certain media query
const Hidden = ({ query, minBreakpoint, maxBreakpoint, children, }) => {
    const [isMatch] = useMatchMedia({
        query,
        minBreakpoint,
        maxBreakpoint,
    });
    return isMatch ? null : React.createElement(React.Fragment, null, children);
};
export default Hidden;
//# sourceMappingURL=Hidden.js.map